class MediaQueries {
  constructor() {
    this.medium_screen = 768;
    this.large_screen = 1024;
    this.current_window = null;
    this.getScreenSize();
    this.screenSizeObserver();
  }

  getScreenSize() {
    const previous_window = this.current_window;
    if (
      window.matchMedia(`only screen and (min-width: ${this.large_screen}px)`)
        .matches
    ) {
      this.current_window = "large";
    } else if (
      window.matchMedia(`only screen and (min-width: ${this.medium_screen}px)`)
        .matches
    ) {
      this.current_window = "medium";
    } else {
      this.current_window = "small";
    }
    return this.current_window !== previous_window;
  }

  screenSizeObserver() {
    new ResizeObserver(() => this.getScreenSize()).observe(document.body);
  }
}

theme.mqs = new MediaQueries();
